import StateType from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  toggleLoadingProduct(state: StateType, isLoading: boolean): void {
    state.loadingProduct = isLoading;
  },
  toggleLoadingModal(state: StateType, isLoading: boolean): void {
    state.loadingModal = isLoading;
  },
  setStocks(state: StateType, stocks: any): void {
    state.stocks = stocks;
  },
  setProductInfo(state: StateType, productInfo: any): void {
    state.productInfo = productInfo;
  },
  setTotal(state: StateType, total: number): void {
    state.total = total;
  },
  setTotalInput(state: StateType, total: number): void {
    state.totalInput = total;
  },
  setTotalOutput(state: StateType, total: number): void {
    state.totalOutput = total;
  },
};
